import {CancellationReason} from "./types";

export const CANCELLATION_REASONS: ReadonlyArray<CancellationReason> = [
  {
    id: "0f3a7755-a987-4112-b664-8cfb2bffa6f8",
    forStatuses: [],
    cancellationReason: "Completed Manual",
  },
  {
    id: "728af804-2b79-4ef6-9d00-c941fc5f87a7",
    forStatuses: [],
    cancellationReason: "Refused to sign via RESIDE",
  },
  {
    id: "c35b8b70-984a-4869-bb8c-c90af3b1220a",
    forStatuses: [],
    cancellationReason: "Transferred",
  },
  {
    id: "46593e46-9b7c-420c-9700-737dd441567c",
    forStatuses: [],
    cancellationReason: "Discharged",
  },
  {
    id: "9114989d-62bf-4e24-b35e-2592c05dec2e",
    forStatuses: [],
    cancellationReason: "Expired",
  },
  {
    id: "5d72c6fe-9044-4a20-8db6-cd83fe87a204",
    forStatuses: [],
    cancellationReason: "Duplicate Workflow",
  },
  {
    id: "18f8f293-60ed-4ead-8913-79c49bbd2807",
    forStatuses: [],
    cancellationReason: "Test Workflow",
  },
  {
    id: "b32afcce-59b9-4a4e-a33c-d39752622fac",
    forStatuses: [],
    cancellationReason: "Did Not Admit",
  },
  {
    id: "53ba5350-e83c-409c-836a-60162779e369",
    forStatuses: [],
    cancellationReason: "Left AMA",
  }
];
